import { faChevronDoubleLeft, faChevronDoubleRight, faChevronLeft, faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IonRouterLink } from "@ionic/react";
import React from "react";

// Styling
import "./Pagination.scss";

export default function Pagination(props: any) {
  const totalPages: number = props.totalPages;
  const currentPage: number = props.currentPage;
  const filterFormat: string = props.filterFormat;
  const firstPage: number = 1;
  const prevPage: number = currentPage > 1 ? currentPage - 1 : currentPage;
  const nextPage: number = currentPage < totalPages ? currentPage + 1 : currentPage;
  const baseUrl = props.baseUrl + (filterFormat ? filterFormat + "/" : "");

  const numberLinkLimit: number = Math.min(3, totalPages);
  let numberLinksStart: number = currentPage > 1 ? currentPage - 1 : currentPage;
  if (numberLinksStart + numberLinkLimit > totalPages && numberLinksStart > 1) {
    numberLinksStart--;
  }
  const numberLinksEnd: number = numberLinksStart + numberLinkLimit;
  let numberLinks = [];
  for (let i = numberLinksStart; i < numberLinksEnd; i++) {
    numberLinks.push(
      <IonRouterLink routerLink={baseUrl + i} key={i} className={`pagination__link pagination__link--number ${currentPage === i ? "pagination__link--number-active" : ""}`}>
        {i}
      </IonRouterLink>,
    );
  }

  return totalPages > 1 ? (
    <div className="pagination">
      <IonRouterLink routerLink={baseUrl + firstPage} className={`pagination__link pagination__link--first pagination__link--icon`}>
        <FontAwesomeIcon icon={faChevronDoubleLeft} />
      </IonRouterLink>
      <IonRouterLink routerLink={baseUrl + prevPage} className={`pagination__link pagination__link--prev pagination__link--icon`}>
        <FontAwesomeIcon icon={faChevronLeft} />
      </IonRouterLink>

      <span className="pagination__numbers">{numberLinks}</span>

      <IonRouterLink routerLink={baseUrl + nextPage} className={`pagination__link pagination__link--next pagination__link--icon`}>
        <FontAwesomeIcon icon={faChevronRight} />
      </IonRouterLink>
      <IonRouterLink routerLink={baseUrl + totalPages} className={`pagination__link pagination__link--last pagination__link--icon`}>
        <FontAwesomeIcon icon={faChevronDoubleRight} />
      </IonRouterLink>
    </div>
  ) : (
    <></>
  );
}
